import React, { Component } from "react";
import {
    View, Image, TouchableOpacity, FlatList,
    Animated, Dimensions, Platform, Linking,
     TouchableWithoutFeedback,
    AppState, BackHandler,
     ScrollView
} from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, componentStyles, requestInfoStyles, profileStyles, walletStyles, viewCartStyles, loginStyles, homeStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor, greenLightColor, greenDarkColor, redColor } from "../theme/colors";
import SessionItem from "../components/SessionItem";
import { orderRequest, cancelOrderRequest, ratePointsRequest, addPointRequest, getRecieptRequest, payOrderRequest, paySessionRequest, doSessionRequest, sendToAllRequest, removeExpertFavRequest, addExpertFavRequest } from "../utils/api";
import Waiting from "../components/Waiting";
import { getStatus, persianNumber, getStatusColor, priceString, getStatusPay, showMessage, getError, getNumber } from "../utils/utils";
var {  height } = Dimensions.get('window');
import { hp, wp } from "../utils/responsive";
import CedarMaps from '@cedarstudios/react-cedarmaps'

import DialogPrompt from '../components/DialogPrompt';
import RatingBar from "../components/RatingBar";
import Button from "../components/Button";

const LATITUDE = 35.724566;
const LONGITUDE = 51.367788;
const styles = {
    icon: {
        iconImage: icons['onmappin'],
        iconSize: 0.3,
        iconAllowOverlap: false,
    },
    iconExper: {
        iconImage: icons['onmappin_safir'],
        iconSize: 0.12,
        iconAllowOverlap: false,
    },
};
var geojson = {
    type: 'FeatureCollection',
    features: [{
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [51.367788, 35.724566]
        },
        properties: {
            title: 'موقعیت انتخابی',
            description: ''
        }
    }]
};


export default class ReqeustInfoScreen extends Component {
    intervalId = 0;
    intervalUpdateId = 0;
    constructor(props) {
        super(props)
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);

        this.state = {
            payTab: 2,
            appState: '',
            gotopay: false,
            selectePay: 0,
            selectedTabRate: 0,
            readyPrompt: false,
            showPayment: false,
            showPaymentSession: false,
            session: [],
            positives: [],
            negatives: [],
            selectedPositive: [],
            selectedNegative: [],
            showPrompt: false,
            promptMessage: '',
            currentSession: null,
            showSession: false,
            walletBalance: 0,
            rate: 0,
            waiting: true,
            expanded: false,
            animation: new Animated.Value(0),
            minHeight: 0,
            maxHeight: height - 70,
            info_order: null,
            order_details: [],
            info_servant: null,
            latitude: 0,
            longitude: 0,
            region: [LONGITUDE, LATITUDE],
            regionGeo: geojson,
            expert: [],
            expertGeo: null,
        }
    }
    _keyExtractor = (item, index) => index.toString();

    renderOrderRow({ item, index }) {
        return <View style={[appStyles.row, {
            justifyContent: 'space-around',
            alignSelf: 'center',
            width: wp(80), borderBottomColor: '#F8F8F8',
            borderBottomWidth: 1,
        }]}>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>{persianNumber(item.number)}</TextView>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>{priceString(item.price)}</TextView>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>{persianNumber(item.servicedetailcode)}</TextView>
            <TextView style={{ width: wp(20), textAlign: 'center' }}>{item.title}</TextView>
        </View>
    }
    renderFooter({ item, index }) {
        return <View style={[appStyles.rowAround, { width: wp(85), marginTop: 20 }]}>
            <View style={appStyles.center}>
                <TextView style={{ margin: 5 }}>جمع فاکتور</TextView>
                <TextView style={appStyles.textCenter}>{priceString(this.state.info_order.price_pay)}</TextView>
            </View>
            <View style={viewCartStyles.lineHorz} />
            <View style={appStyles.center}>
                <TextView style={{ margin: 5 }}>هزینه رفت و آمد</TextView>
                <TextView style={appStyles.textCenter}>{priceString(this.state.info_order.price_sweep)}</TextView>
            </View>
            <View style={viewCartStyles.lineHorz} />
            <View style={appStyles.center}>
                <TextView style={{ margin: 5 }}>هزینه بیمه</TextView>
                <TextView style={appStyles.textCenter}>{priceString(this.state.info_order.price_insurance)}</TextView>
            </View>
        </View>
    }
    renderNormalHeader() {
        return <View style={{ paddingLeft: 30, paddingRight: 30 }}>
            <View style={[appStyles.rowBetween, { marginBottom: 5, marginTop: 5 }]}>
                <View style={[componentStyles.statusWraper, { backgroundColor: getStatusColor(this.state.showSession, this.state.info_order.status_order, []) }]}>
                    <TextView style={{ color: 'white', fontSize: 10 }}>{getStatus(this.state.showSession, this.state.info_order.status_order, 'در حال انجام')}</TextView>
                </View>
                <View style={appStyles.row}>
                    <TextView style={[appStyles.rightText]}>{this.state.info_order.title_service}</TextView>
                    <LinearGradient colors={[blueDarkColor, blueLightColor]} style={componentStyles.requestImageWraper}>
                        <Image
                            source={{ uri: this.state.order_details[0].imageurl }}
                            style={componentStyles.serviceImage} />
                    </LinearGradient>
                </View>
            </View>
            <View style={[appStyles.rowBetween, { padding: 0, marginBottom: 20 }]}>
                <TextView style={{ fontSize: 10 }}>{persianNumber(this.state.info_order.date_create)}</TextView>
                <TextView style={[appStyles.rightText, { fontSize: 10 }]}>شماره سفارش : {this.state.info_order.trackingcode}</TextView>
            </View>
            {this.state.showSession ? <View style={requestInfoStyles.headerWraper}>
                <TextView style={[appStyles.textCenter, { width: wp(20) }]}>پرداخت</TextView>
                <TextView style={[appStyles.textCenter, { width: wp(20) }]}>تاریخ</TextView>
                <TextView style={[appStyles.textCenter, { width: wp(20) }]}>نام سفیر سلامت</TextView>
                <TextView style={[appStyles.textCenter, { width: wp(20) }]}>جلسه</TextView>
            </View> : <View style={requestInfoStyles.headerWraper}>
                    <TextView style={[appStyles.textCenter, { width: wp(20) }]}>تعداد</TextView>
                    <TextView style={[appStyles.textCenter, { width: wp(20) }]}>قیمت</TextView>
                    <TextView style={[appStyles.textCenter, { width: wp(20) }]}>کد</TextView>
                    <TextView style={[appStyles.textCenter, { width: wp(20) }]}>عنوان خدمت</TextView>
                </View>}
        </View>
    }
    renderHeader() {
        return <View style={requestInfoStyles.headerWraper}>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>پرداخت</TextView>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>تاریخ</TextView>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>نام سفیر سلامت</TextView>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>جلسه</TextView>
        </View>
    }
    renderOrderHeader() {
        return <View style={requestInfoStyles.headerWraper}>

            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>تعداد</TextView>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>قیمت</TextView>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>کد</TextView>
            <TextView style={[appStyles.textCenter, { width: wp(20) }]}>عنوان خدمت</TextView>
        </View>
    }
    renderButtonFooter() {
        return <View style={appStyles.center}>

            <TouchableOpacity style={{ alignSelf: 'center', margin: 20 }} activeOpacity={0.5} onPress={() => {
                this.setState({
                    waiting: true
                })
                getRecieptRequest(this.props.route.params.id, (isConnect, response) => {
                    this.setState({
                        waiting: false
                    })
                    if (isConnect && response.isSuccess) {
                        showMessage('', response.message);
                        this.toggle()
                    } else {
                        showMessage('', getError(response))
                    }
                })

            }}>
                <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[blueLightColor, blueDarkColor]} style={[componentStyles.gradinatButton, { width: 150, height: 50 }]}>
                    <TextView style={{ color: 'white' }}>دریافت رسید</TextView>
                    <Image source={icons['invoice']} style={componentStyles.smallIconWhite} />
                </LinearGradient>
            </TouchableOpacity>
            {this.state.info_servant != null ? <View style={[{ width: wp(85), justifyContent: 'center', alignItems: 'center' }]}>

                <TextView style={{ textAlign: 'center', margin: 10, color: 'gray' }}>در صورتی که تمایل دارید درمانگر زیر به لیست منتخب شما اضافه شود دکمه افزودن به لیست را بزنید</TextView>
                <View style={[{ backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', borderRadius: 8, padding: 10, marginBottom: 10, width: wp(80) }, appStyles.shadow]}>
                    <View style={[appStyles.row, { marginRight: 5 }]}>

                        <View style={{ marginRight: 20 }}>
                            <TextView style={{ color: '#424242' }}>{this.state.info_servant.servant_name}</TextView>
                            <TextView style={{ color: 'gray', margin: 5, textAlign: 'right' }}>({this.state.info_servant.job_name})</TextView>
                        </View>
                        <View style={componentStyles.fservantImage}>
                            <Image
                                source={{ uri: this.state.info_servant.servant_pic }}
                                style={componentStyles.iservantImage} />
                        </View>
                    </View>
                    <TouchableOpacity style={[componentStyles.addfavWraper, { alignSelf: 'center' }]} onPress={() => {
                        this.setState({
                            waiting: true
                        })
                        if (this.state.info_servant.add_fav) {

                            removeExpertFavRequest(this.state.info_servant.id_servant, (isConnect, response) => {

                                if (isConnect) {
                                    this.getData(this.props)
                                }
                            })
                        } else {
                            addExpertFavRequest(this.state.info_servant.id_servant, (isConnect, response) => {

                                if (isConnect) {
                                    this.getData(this.props)
                                }
                            })
                        }

                    }}>
                        <Image source={this.state.info_servant.add_fav ? icons['like_fill'] : icons['like']} style={appStyles.smallIcon} />
                        <TextView style={{ fontSize: 10, color: 'gray', marginLeft: 15, width: wp(25), textAlign: 'right' }}>{this.state.info_servant.add_fav ? 'حذف از لیست' : 'افزودن به لیست'}</TextView>

                    </TouchableOpacity>
                </View>
            </View> : null}
        </View>
    }
    renderRateRow({ item, index }) {
        var color = this.state.selectedTabRate === 1 ? redColor : greenDarkColor;
        var selected = this.state.selectedTabRate === 1 ? this.state.selectedNegative.filter(it => it === item.id) : this.state.selectedPositive.filter(it => it === item.id);
        return <TouchableOpacity style={[{ width: wp(40), borderRadius: 8, margin: 5, height: hp(7), justifyContent: 'center', alignItems: 'center' },
        selected.length > 0 ? { borderWidth: 1, borderColor: color } :
            { borderWidth: 1, borderColor: '#F8F8F8' }]} onPress={() => {
                if (this.state.selectedTabRate === 0) {
                    var rates = this.state.selectedPositive;
                    if (selected > 0) {
                        rates = this.state.selectedPositive.filter(it => it !== item.id);
                    } else {
                        rates.push(item.id);
                    }
                    this.setState({
                        selectedPositive: rates
                    })

                } else {
                    var rates = this.state.selectedNegative;
                    if (selected > 0) {
                        rates = this.state.selectedNegative.filter(it => it !== item.id);
                    } else {
                        rates.push(item.id);
                    }

                    this.setState({
                        selectedNegative: rates
                    })
                }
            }}>
            <TextView isbold={selected.length > 0} style={{ color: selected.length > 0 ? color : 'black', fontSize: 12 }}>{item.text}</TextView>
        </TouchableOpacity>
    }

    render() {

        if (this.state.info_order != null) {
            if (this.state.info_order.status_order === 'end') {
                if (this.state.info_order.status_comment) {
                    return this.normalUI();
                } else {
                    return this.commentUI()
                }
            } else if (this.state.info_order.status_order === 'cancelled') {
                return this.normalUI();
            } else if (this.state.info_order.status_order === 'arrived') {
                return this.mapUI();
            } else if (this.state.info_order.status_order === 'getservant') {
                if (this.state.showSession) {
                    if (this.state.currentSession != null) {
                        if (this.state.currentSession.status_servant === 'start') {
                            return this.mapUI();
                        } else if (this.state.currentSession.status_servant === 'arrived') {
                            return this.mapUI();
                        } else {
                            return this.normalUI();
                        }
                    } else {
                        return this.normalUI();
                    }
                } else {
                    return this.mapUI();
                }
            } else {
                return this.waitingUI();
            }
        } else {
            if (this.state.waiting) {
                return <View style={{ flex: 1 }}>
                    <Waiting waiting={this.state.waiting} />
                </View>
            } else {
                return <View />
            }

        }
    }
    renderSessionRow({ item, index }) {

        return <SessionItem data={item} servant={this.state.info_servant} onPayment={() => {
            this.setState({
                showPaymentSession: true,
            })
        }} />

    }
    normalUI() {
        return <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ flex: 1 }}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>جزییات درخواست</TextView>
                <TouchableOpacity onPress={() => {
                    if(this.props.navigation.canGoBack()) {
                        this.props.navigation.goBack()
                    }else {
                        Linking.openURL('/requestList')
                    }


                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <View style={requestInfoStyles.infoWraper}>
                <View style={{ width: wp(100), justifyContent: 'center' }}>
                    {this.state.showSession ? <FlatList
                        data={this.state.order_details[0].sessions}
                        ListHeaderComponent={this.renderNormalHeader.bind(this)}
                        renderItem={this.renderSessionRow.bind(this)}
                        ListFooterComponent={this.renderButtonFooter.bind(this)}
                        keyExtractor={this._keyExtractor} /> :
                        <FlatList
                            data={this.state.order_details}
                            ListHeaderComponent={this.renderNormalHeader.bind(this)}
                            renderItem={this.renderOrderRow.bind(this)}
                            ListFooterComponent={this.renderButtonFooter.bind(this)}
                            keyExtractor={this._keyExtractor} />}

                </View>
            </View>

            <Animated.View style={[appStyles.bottomView, appStyles.shadow, { height: this.state.animation, minHeight: 0 }]}>
                {this.state.expanded ? <LinearGradient colors={[blueDarkColor, blueLightColor]} style={[profileStyles.wraper, { justifyContent: 'flex-start' }]}>

                    <TouchableOpacity onPress={() => {
                        this.toggle()
                    }}>
                        <Image source={icons['dropdown']} style={[appStyles.dropdown, { tintColor: 'white' }]} />
                    </TouchableOpacity>
                    <ScrollView showsVerticalScrollIndicator={false}>
                    <View style={walletStyles.walletBox}>
                        <View style={[appStyles.boxWraper]}>
                            <TextView style={{ margin: 10 }}>نوع پرداخت : {getStatusPay(this.state.info_order.status_pay)}</TextView>
                            <View style={[appStyles.rowAround, { marginBottom: 10 }]}>
                                <View style={[appStyles.center, { marginRight: 15 }]}>
                                    <TextView style={{ margin: 5 }}>تاریخ سفارش</TextView>
                                    <TextView>{persianNumber(this.state.info_order.date_create)}</TextView>
                                </View>
                                <View style={appStyles.center}>
                                    <TextView style={{ margin: 5 }}>شماره سفارش</TextView>
                                    <TextView>{this.state.info_order.trackingcode}</TextView>
                                </View>
                            </View>
                            <FlatList
                                data={this.state.order_details}
                                ListHeaderComponent={this.renderOrderHeader.bind(this)}
                                renderItem={this.renderOrderRow.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                keyExtractor={this._keyExtractor} />

                        </View>
                        <View style={walletStyles.diamondWraper}>
                            <Image source={icons['invoice']} style={[appStyles.toolbarIcon, { tintColor: blueDarkColor }]} />
                        </View>
                    </View>
                    </ScrollView>
                </LinearGradient> : null}
            </Animated.View>
            <Waiting waiting={this.state.waiting} />
            {this.paymentUI()}
            {this.state.currentSession != null ?
                <DialogPrompt
                    show={this.state.readyPrompt}
                    message={'سفیر آد ، درخواست انجام جلسه ' + getNumber(this.state.currentSession.session_number) + ' را دارد آیا قبول می کنید ؟ '}
                    approve='بله'
                    cancel='خیر'
                    onApprove={() => {
                        this.setState({
                            readyPrompt: false,
                            waiting: true,
                        }, () => {
                            doSessionRequest(this.state.currentSession.id_session, 'yes', (isConnect, response) => {
                                this.setState({
                                    waiting: false
                                })
                                if (isConnect && response.isSuccess) {
                                    this.getData(this.props);
                                } else {
                                    showMessage('', getError(response));
                                }
                            })
                        })


                    }}
                    onCancel={() => {
                        this.setState({
                            readyPrompt: false,
                            waiting: true
                        }, () => {
                            doSessionRequest(this.state.currentSession.id_session, 'no', (isConnect, response) => {
                                this.setState({
                                    waiting: false
                                })
                                if (isConnect && response.isSuccess) {
                                    this.getData(this.props);
                                } else {
                                    showMessage('', getError(response));
                                }
                            })
                        })

                    }}
                    onClose={() => {
                        this.setState({
                            readyPrompt: false
                        })
                    }} /> : null}
        </ScrollView>
    }
    commentUI() {
        return <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ flex: 1 }}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>بازخورد خدمات دهی</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <ScrollView showsVerticalScrollIndicator={false}>
                <TextView style={{ textAlign: 'center', marginTop: 20, marginBottom: 20 }}>باز خورد خود را نسبت به خدمات ارائه شده, اعلام کنید</TextView>
                <RatingBar
                    style={{ padding: 10 }}
                    enable={true}
                    rate={this.state.rate}
                    onRate={(rate) => {
                        this.setState({
                            rate: rate
                        })
                    }} />
                <View style={[appStyles.row, appStyles.center]}>
                    <TouchableOpacity style={[appStyles.row, appStyles.center,
                    { width: wp(30), height: hp(6) },
                    this.state.selectedTabRate === 1 ? { borderBottomColor: redColor, borderBottomWidth: 2 } : null]}
                        onPress={() => {
                            this.setState({
                                selectedTabRate: 1,
                            })
                        }}>
                        {this.state.selectedNegative.length > 0 ? <View style={[{ backgroundColor: redColor, width: 20, height: 20, borderRadius: 10, marginRight: 10 }, appStyles.center]}>
                            <TextView style={{ fontSize: 10, color: 'white' }}>{persianNumber(this.state.selectedNegative.length)}</TextView>
                        </View> : null}
                        <TextView>نقاط ضعف</TextView>
                    </TouchableOpacity>
                    <TouchableOpacity style={[appStyles.row, appStyles.center,
                    { width: wp(30), height: hp(6) },
                    this.state.selectedTabRate === 0 ? { borderBottomColor: greenDarkColor, borderBottomWidth: 2 } : null]}
                        onPress={() => {
                            this.setState({
                                selectedTabRate: 0
                            })
                        }}>
                        {this.state.selectedPositive.length > 0 ? <View style={[{ backgroundColor: greenDarkColor, width: 20, height: 20, borderRadius: 10, marginRight: 10 }, appStyles.center]}>
                            <TextView style={{ fontSize: 10, color: 'white' }}>{persianNumber(this.state.selectedPositive.length)}</TextView>
                        </View> : null}
                        <TextView >نقاط قوت</TextView>
                    </TouchableOpacity>
                </View>
                <View style={[appStyles.center, { marginTop: 10 }]}>
                    {this.state.selectedTabRate === 0 ?
                        <FlatList
                            data={this.state.positives}
                            numColumns={2}
                            extraData={this.state}
                            renderItem={this.renderRateRow.bind(this)}
                            keyExtractor={this._keyExtractor} /> :
                        <FlatList
                            data={this.state.negatives}
                            numColumns={2}
                            extraData={this.state}
                            renderItem={this.renderRateRow.bind(this)}
                            keyExtractor={this._keyExtractor} />}
                </View>

                <Button
                    style={{
                        width: wp(40), height: hp(6),
                        marginTop: 10,
                        borderRadius: hp(6) / 2, alignSelf: 'center'
                    }}
                    text='ثبت بازخورد'
                    textStyle={{ color: 'white', textAlign: 'center' }}
                    onPress={() => {
                        if (this.state.rate !== 0) {
                            var pointIds = '';
                            this.state.selectedPositive.map(item => {
                                if (pointIds.length === 0) {
                                    pointIds += '' + item;
                                } else {
                                    pointIds += ',' + item
                                }
                            })
                            this.state.selectedNegative.map(item => {
                                if (pointIds.length === 0) {
                                    pointIds += '' + item;
                                } else {
                                    pointIds += ',' + item
                                }
                            })

                            this.setState({
                                waiting: true
                            })
                            addPointRequest(this.props.route.params.id,
                                this.state.rate, pointIds, (isConnect, response) => {

                                    if (isConnect && response.isSuccess) {
                                        this.getData(this.props)
                                    } else {
                                        this.setState({
                                            waiting: false,
                                        })
                                        showMessage('', getError(response))
                                    }
                                })

                        } else {
                            showMessage('', 'لطفا میزان رضایت خود را انتخاب نمایید')
                        }


                    }}
                />
            </ScrollView>
            <Waiting waiting={this.state.waiting} />
        </ScrollView>
    }
    mapUI() {
        const {Marker,Layer}=CedarMaps.getReactMapboxGl();
        return <View style={{ flex: 1 }}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>جزییات درخواست</TextView>
                <View />
            </View>
            <View style={[appStyles.shadow, { backgroundColor: 'white', height: hp(93), borderTopLeftRadius: 40, borderTopRightRadius: 40 }]}>
                <View style={{ height: hp(10), alignItems: 'center', justifyContent: 'center' }}>
                    <TextView style={[appStyles.textCenter, { fontSize: hp(2.2), marginTop: 5, marginBottom: 5 }]}>{priceString(this.state.info_order.price_pay)} تومان</TextView>
                    {this.state.currentSession == null && (this.state.info_order.status_pay == null ||
                        this.state.info_order.status_pay.length === 0
                        || this.state.info_order.status_pay === 'cpay') ? <TextView style={[appStyles.textCenter, { color: this.state.info_order.bag_value ? greenDarkColor : redColor }]}> موجودی کافی {this.state.info_order.bag_value ? 'است' : 'نیست'}</TextView> : null}
                    {this.state.currentSession != null && (this.state.currentSession.status_pay == null ||
                        this.state.currentSession.status_pay.length === 0 ||
                        this.state.currentSession.status_pay === 'cpay') ? <TextView style={[appStyles.textCenter, { color: this.state.info_order.bag_value ? greenDarkColor : redColor }]}> موجودی کافی {this.state.info_order.bag_value ? 'است' : 'نیست'}</TextView> : null}
                </View>
                <CedarMaps
                    logoPosition='top-left'
                    containerStyle={{
                        height: hp(39), borderTopLeftRadius: 50,
                        borderTopRightRadius: 50,
                    }}
                    token='de1f4bf85b1e70f435a36cc27a5a61075793a194'
                    center={this.state.expert}
                >
                    <Marker
                        coordinates={this.state.region}
                        anchor="bottom">
                        <Image source={icons['onmappin']} style={{width:50,height:50,resizeMode:'contain'}}/>
                    </Marker>
                    <Marker
                        coordinates={this.state.expert}
                        anchor="bottom">
                        <Image source={icons['onmappin_safir']} style={{width:30,height:30,resizeMode:'contain'}}/>
                    </Marker>
                    {/*{this.state.expertGeo != null ? <ShapeSource*/}
                    {/*    id="symbolLocationSource"*/}
                    {/*    hitbox={{ width: 30, height: 30 }}*/}
                    {/*    anchor={{ x: 0.5, y: 1 }}*/}
                    {/*    shape={this.state.expertGeo}>*/}

                    {/*    <Layer*/}
                    {/*        id="symbolLocationSymbols"*/}
                    {/*        style={styles.iconExper}*/}
                    {/*    />*/}
                    {/*</ShapeSource> : null}*/}
                </CedarMaps>

                <LinearGradient colors={[blueDarkColor, blueLightColor]} style={[profileStyles.wraper, { height: hp(41) }]}>
                    <View style={[walletStyles.walletBox, { marginTop: (wp(20) / 2) }]}>

                        <View style={[requestInfoStyles.boxWraper, { height: wp(28) }]}>
                            {/* <View style={appStyles.rowAround}>
                                <TouchableOpacity style={{ padding: 5 }} onPress={() => {
                                    this.setState({
                                        waiting: true
                                    })
                                    if (this.state.info_servant.add_fav) {

                                        removeExpertFavRequest(this.state.info_servant.id_servant, (isConnect, response) => {

                                            if (isConnect) {
                                                this.getData(this.props)
                                            }
                                        })
                                    } else {
                                        addExpertFavRequest(this.state.info_servant.id_servant, (isConnect, response) => {

                                            if (isConnect) {
                                                this.getData(this.props)
                                            }
                                        })
                                    }

                                }}>
                                    <Image source={this.state.info_servant.add_fav ? icons['like_fill'] : icons['like']} style={appStyles.smallIcon} />
                                </TouchableOpacity> */}
                            <TextView style={{ margin: 5 }}>{this.state.info_servant.servant_name}</TextView>

                            {/* </View> */}
                            <TextView style={{ margin: 5, color: '#4D4C53', fontSize: hp(1.7) }}>{this.state.info_servant.job_name}</TextView>
                            {this.state.info_servant.num_nezam != null && this.state.info_servant.num_nezam.length > 0 ?
                                <TextView style={{ margin: 5, color: '#4D4C53', fontSize: hp(1.7) }}>{this.state.info_servant.topic_nezam} : {this.state.info_servant.num_nezam}</TextView> : null}
                            <Waiting waiting={this.state.waiting} />
                        </View>
                        <View style={requestInfoStyles.diamondWraper}>
                            <Image
                                source={{ uri: this.state.info_servant.servant_pic }}
                                style={componentStyles.servantImage} />
                        </View>
                    </View>
                    <View style={[appStyles.bottomView, appStyles.rowBetween, { height: hp(13), minHeight: hp(13) }]}>
                        <TouchableOpacity activeOpacity={0.5}
                            onPress={() => {
                                if (this.state.currentSession != null) {
                                    if (this.state.currentSession.status_pay == null || this.state.currentSession.status_pay.length === 0 || this.state.currentSession.status_pay === 'cpay') {
                                        this.setState({
                                            showPaymentSession: true,
                                        })
                                    }
                                } else {
                                    if (this.state.info_order.status_pay == null || this.state.info_order.status_pay.length === 0 || this.state.info_order.status_pay === 'cpay') {
                                        this.setState({
                                            showPayment: true
                                        })
                                    }
                                }
                            }}>
                            <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[blueLightColor, blueDarkColor]}
                                style={[componentStyles.gradinatButton, { width: wp(45), borderRadius: hp(8) / 2, height: hp(8) }]}>
                                {this.state.currentSession == null ? <TextView style={componentStyles.requestText}>{
                                    this.state.info_order.status_pay == null ||
                                        this.state.info_order.status_pay.length === 0
                                        || this.state.info_order.status_pay === 'cpay' ? 'پرداخت هزینه' : 'پرداخت شد'}</TextView> : null}
                                {this.state.currentSession != null ? <TextView style={componentStyles.requestText}>{
                                    this.state.currentSession.status_pay == null ||
                                        this.state.currentSession.status_pay.length === 0 ||
                                        this.state.currentSession.status_pay === 'cpay' ? 'پرداخت هزینه' : 'پرداخت شد'}</TextView> : null}
                                <Image source={icons['card']} style={{ width: wp(8), height: wp(8), resizeMode: 'contain', marginRight: 15 }} />

                            </LinearGradient>
                        </TouchableOpacity>
                        <TouchableOpacity activeOpacity={0.5}
                            onPress={() => {
                                Linking.openURL('tel:' + this.state.info_servant.cellphone);
                            }}>
                            <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[greenLightColor, greenDarkColor]}
                                style={[componentStyles.gradinatButton, { width: wp(45), borderRadius: hp(8) / 2, height: hp(8) }]}>
                                <TextView style={componentStyles.requestText}>تماس بگیرید</TextView>
                                <Image source={icons['call']} style={{ width: wp(8), height: wp(8), resizeMode: 'contain', marginRight: 15 }} />
                            </LinearGradient>
                        </TouchableOpacity>
                    </View>
                </LinearGradient>
            </View>
            {this.paymentUI()}
            {this.state.currentSession != null ?
                <DialogPrompt
                    show={this.state.readyPrompt}
                    message={'سفیر آد ، درخواست انجام جلسه ' + getNumber(this.state.currentSession.session_number) + ' را دارد آیا قبول می کنید ؟ '}
                    approve='بله'
                    cancel='خیر'
                    onApprove={() => {
                        this.setState({
                            readyPrompt: false,
                            waiting: true,
                        }, () => {
                            doSessionRequest(this.state.currentSession.id_session, 'yes', (isConnect, response) => {
                                this.setState({
                                    waiting: false
                                })
                                if (isConnect && response.isSuccess) {
                                    this.getData(this.props);
                                } else {
                                    showMessage('', getError(response));
                                }
                            })
                        })


                    }}
                    onCancel={() => {
                        this.setState({
                            readyPrompt: false,
                            waiting: true
                        }, () => {
                            doSessionRequest(this.state.currentSession.id_session, 'no', (isConnect, response) => {
                                this.setState({
                                    waiting: false
                                })
                                if (isConnect && response.isSuccess) {
                                    this.getData(this.props);
                                } else {
                                    showMessage('', getError(response));
                                }
                            })
                        })

                    }}
                    onClose={() => {
                        this.setState({
                            readyPrompt: false
                        })
                    }} /> : null}
        </View>
    }
    paymentUI() {

        return <View style={{flex:1,position:'absolute',alignSelf:'center'}}>
            {this.state.showPayment && <TouchableWithoutFeedback onPress={() => {
                    this.setState({
                        showPayment: false
                    })
                }}>
                    <View style={appStyles.modalMessageAbsolute} >
                        <TouchableWithoutFeedback onPress={() => {

                        }}>
                            <View style={appStyles.modalContent}>
                                <TextView style={{ marginBottom: 20 }}>مبلغ قابل پرداخت</TextView>
                                <TextView style={{ fontSize: 16, textAlign: 'center', margin: 5 }}>{priceString(this.state.info_order.price_pay)} تومان</TextView>
                                <View style={[appStyles.rowAround, { marginTop: 10, marginBottom: 30 }]}>

                                    <TouchableOpacity style={this.state.payTab === 2 ? componentStyles.paymentActiveButton : componentStyles.paymentButton} onPress={() => {
                                        this.setState({
                                            payTab: 2
                                        })
                                    }}>
                                        <TextView style={this.state.payTab === 2 ? componentStyles.paymentTextActive : componentStyles.payementText}>پرداخت نقدی</TextView>
                                    </TouchableOpacity>

                                    <TouchableOpacity style={this.state.payTab === 1 ? componentStyles.paymentActiveButton : componentStyles.paymentButton} onPress={() => {
                                        this.setState({
                                            payTab: 1
                                        })
                                    }}>
                                        <TextView style={this.state.payTab === 1 ? componentStyles.paymentTextActive : componentStyles.payementText}>پرداخت آنلاین</TextView>
                                    </TouchableOpacity>

                                    <TouchableOpacity style={this.state.payTab === 0 ? componentStyles.paymentActiveButton : componentStyles.paymentButton} onPress={() => {
                                        this.setState({
                                            payTab: 0
                                        })
                                    }}>
                                        <TextView style={this.state.payTab === 0 ? componentStyles.paymentTextActive : componentStyles.payementText}>کیف پول</TextView>
                                    </TouchableOpacity>
                                </View>
                                <TouchableOpacity activeOpacity={0.5}
                                    onPress={() => {
                                        this.setState({
                                            waiting: true,
                                            showPayment: false
                                        })
                                        payOrderRequest(this.props.route.params.id, this.getTypeOrder(), (isConnect, response) => {
                                            this.setState({
                                                waiting: true
                                            })
                                            if (isConnect && response.isSuccess) {
                                                if (this.getTypeOrder() === 'epay') {
                                                    Linking.openURL(response.data.link_pay)
                                                } else {
                                                    showMessage('', response.message)
                                                }
                                                this.getData(this.props)
                                            } else {
                                                showMessage('', getError(response));
                                            }
                                        })
                                    }}>
                                    <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[greenLightColor, greenDarkColor]}
                                        style={[componentStyles.gradinatButton, { width: wp(45), borderRadius: hp(6) / 2, height: hp(6) }]}>
                                        <TextView style={componentStyles.requestText}>پرداخت</TextView>
                                    </LinearGradient>
                                </TouchableOpacity>
                            </View>
                        </TouchableWithoutFeedback>
                    </View>
                </TouchableWithoutFeedback>}
            {this.state.showPaymentSession && <TouchableWithoutFeedback onPress={() => {
                    this.setState({
                        showPaymentSession: false
                    })
                }}>
                    <View style={appStyles.modalMessageAbsolute} >
                        <TouchableWithoutFeedback onPress={() => {

                        }}>
                            <View style={appStyles.modalContent}>
                                <TextView style={{ marginBottom: 20 }}>شرایط پرداخت را انتخاب کنید</TextView>
                                <View style={[appStyles.center, appStyles.row]}>

                                    <TouchableOpacity style={this.state.selectePay === 1 ?
                                        componentStyles.selectActivePay :
                                        componentStyles.selectPay} onPress={() => {
                                            this.setState({
                                                selectePay: 1
                                            })
                                        }}>
                                        <TextView style={{ fontSize: 12, color: '#4D4C53' }}>(کل)</TextView>
                                        <TextView>{priceString(this.state.info_order.remaindprice_order)} تومان</TextView>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={this.state.selectePay === 0 ?
                                        componentStyles.selectActivePay :
                                        componentStyles.selectPay} onPress={() => {
                                            this.setState({
                                                selectePay: 0
                                            })
                                        }}>
                                        <TextView style={{ fontSize: 12, color: '#4D4C53' }}>(یک جلسه)</TextView>
                                        <TextView>{priceString(this.state.info_order.onesession_price)} تومان</TextView>
                                    </TouchableOpacity>
                                </View>
                                <View style={[appStyles.rowAround, { marginTop: 20, marginBottom: 30 }]}>

                                    <TouchableOpacity style={this.state.payTab === 2 ? componentStyles.paymentActiveButton : componentStyles.paymentButton} onPress={() => {
                                        this.setState({
                                            payTab: 2
                                        })
                                    }}>
                                        <TextView style={this.state.payTab === 2 ? componentStyles.paymentTextActive : componentStyles.payementText}>پرداخت نقدی</TextView>
                                    </TouchableOpacity>

                                    <TouchableOpacity style={this.state.payTab === 1 ? componentStyles.paymentActiveButton : componentStyles.paymentButton} onPress={() => {
                                        this.setState({
                                            payTab: 1
                                        })
                                    }}>
                                        <TextView style={this.state.payTab === 1 ? componentStyles.paymentTextActive : componentStyles.payementText}>پرداخت آنلاین</TextView>
                                    </TouchableOpacity>

                                    <TouchableOpacity style={this.state.payTab === 0 ? componentStyles.paymentActiveButton : componentStyles.paymentButton} onPress={() => {
                                        this.setState({
                                            payTab: 0
                                        })
                                    }}>
                                        <TextView style={this.state.payTab === 0 ? componentStyles.paymentTextActive : componentStyles.payementText}>کیف پول</TextView>
                                    </TouchableOpacity>
                                </View>
                                <TouchableOpacity activeOpacity={0.5}
                                    onPress={() => {
                                        this.setState({
                                            waiting: true,
                                            showPaymentSession: false,
                                        })
                                        paySessionRequest(this.state.currentSession.id_session, this.state.selectePay === 0 ? 'session' : 'order', this.getTypeOrder(), (isConnect, response) => {
                                            this.setState({
                                                waiting: true
                                            })
                                            if (isConnect && response.isSuccess) {
                                                if (this.getTypeOrder() === 'epay') {
                                                    Linking.openURL(response.data.link_pay);
                                                } else {
                                                    showMessage('', response.message);
                                                }
                                                this.getData(this.props)
                                            } else {
                                                showMessage('', getError(response))
                                            }
                                        })
                                    }}>
                                    <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[greenLightColor, greenDarkColor]}
                                        style={[componentStyles.gradinatButton, { width: wp(45), borderRadius: hp(6) / 2, height: hp(6) }]}>
                                        <TextView style={componentStyles.requestText}>پرداخت</TextView>
                                    </LinearGradient>
                                </TouchableOpacity>
                            </View>
                        </TouchableWithoutFeedback>
                    </View>
                </TouchableWithoutFeedback>}
        </View>
    }
    getTypeOrder() {
        if (this.state.payTab === 0) {
            return 'bag'
        } else if (this.state.payTab === 1) {
            return 'epay'
        } else if (this.state.payTab === 2) {
            return 'cpay'
        }
    }

    waitingUI() {
        return <View style={{ flex: 1 }}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>جزییات درخواست</TextView>
                <View />
            </View>
            <View style={profileStyles.wraper}>
                <TextView isbold={true} style={{ color: '#009cb3', textAlign: 'center', marginTop: 20, fontSize: hp(2.4) }}>در حال یافتن نزدیک ترین سفیر سلامت</TextView>
                <TouchableOpacity
                    activeOpacity={1}>
                    <Image
                        source={icons['waiting_expert']}
                        style={{
                            width: wp(60),
                            height: hp(45),
                        }} />
                </TouchableOpacity>
                <View style={{ height: hp(35), justifyContent: 'space-around', alignItems: 'center' }}>
                    <TouchableOpacity style={[{ backgroundColor: '#ef5350', alignSelf: 'center', width: wp(60), height: hp(6), borderRadius: 8 }, appStyles.center, appStyles.shadow]} onPress={() => {
                        this.setState({
                            showPrompt: true,
                            promptMessage: 'آیا میخواهید این درخواست را لغو نمایید؟'
                        })
                    }}>
                        <TextView isbold={true} style={{ color: 'white', textAlign: 'center', fontSize: hp(2.4) }}>لغو درخواست سفیر</TextView>
                    </TouchableOpacity>
                    {/*{this.state.info_order != null && this.state.info_order.is_fav ? <TouchableOpacity onPress={() => {*/}

                    {/*    Linking.openURL('tel:' + this.state.info_order.cellphone_fav)*/}
                    {/*}}>*/}
                    {/*    <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }}*/}
                    {/*        colors={[greenLightColor, greenDarkColor]} style={[homeStyles.favExbutton, { width: wp(60), height: hp(6), margin: 0 }]}>*/}
                    {/*        <TextView isbold={true} style={{ color: 'white', fontSize: hp(2.4) }}>تماس با درمانگر منتخب</TextView>*/}
                    {/*    </LinearGradient>*/}
                    {/*</TouchableOpacity> : null}*/}
                    {this.state.info_order != null && this.state.info_order.is_fav ? <TouchableOpacity style={[componentStyles.addfavWraper, { marginTop: 0, borderColor: 'gray' }]} onPress={() => {
                        this.setState({
                            waiting: true
                        })
                        sendToAllRequest(this.props.route.params.id, (isConnect, response) => {
                            if (isConnect && response.isSuccess) {
                                this.getData(this.props);
                            } else {
                                showMessage('', getError(response))
                            }
                        })
                    }}>
                        <TextView isbold={true} style={{ margin: 5, color: 'gray' }}>ارسال درخواست به سایر درمانگران</TextView>
                    </TouchableOpacity> : null}

                </View>
            </View>
            <DialogPrompt
                show={this.state.showPrompt}
                message={this.state.promptMessage}
                approve='بله'
                cancel='خیر'
                onApprove={() => {
                    this.setState({
                        showPrompt: false,
                        waiting: true,
                    }, () => {
                        cancelOrderRequest(this.props.route.params.id, (isConnect, response) => {
                            if (isConnect && response.isSuccess) {
                                Linking.openURL('https://client.asandarman.ir/')
                            } else {
                                showMessage('', getError(response))
                            }
                        })
                    })


                }}
                onCancel={() => {
                    this.setState({
                        showPrompt: false
                    })

                }}
                onClose={() => {
                    this.setState({
                        showPrompt: false
                    })
                }} />
            <Waiting waiting={this.state.waiting} />
            {this.state.currentSession != null ?
                <DialogPrompt
                    show={this.state.readyPrompt}
                    message={'سفیر آد ، درخواست انجام جلسه ' + getNumber(this.state.currentSession.session_number) + ' را دارد آیا قبول می کنید ؟ '}
                    approve='بله'
                    cancel='خیر'
                    onApprove={() => {
                        this.setState({
                            readyPrompt: false,
                            waiting: true,
                        }, () => {
                            doSessionRequest(this.state.currentSession.id_session, 'yes', (isConnect, response) => {
                                this.setState({
                                    waiting: false
                                })
                                if (isConnect && response.isSuccess) {
                                    this.getData(this.props);
                                } else {
                                    showMessage('', getError(response));
                                }
                            })
                        })


                    }}
                    onCancel={() => {
                        this.setState({
                            readyPrompt: false,
                            waiting: true
                        }, () => {
                            doSessionRequest(this.state.currentSession.id_session, 'no', (isConnect, response) => {
                                this.setState({
                                    waiting: false
                                })
                                if (isConnect && response.isSuccess) {
                                    this.getData(this.props);
                                } else {
                                    showMessage('', getError(response));
                                }
                            })
                        })

                    }}
                    onClose={() => {
                        this.setState({
                            readyPrompt: false
                        })
                    }} /> : null}
        </View>
    }
    toggle() {
        let initialValue = this.state.expanded ? this.state.maxHeight + this.state.minHeight : this.state.minHeight,
            finalValue = this.state.expanded ? this.state.minHeight : this.state.maxHeight + this.state.minHeight;

        this.setState({
            expanded: !this.state.expanded
        });

        this.state.animation.setValue(initialValue);
        Animated.spring(
            this.state.animation,
            {
                toValue: finalValue
            }
        ).start();
    }

    componentWillMount() {
        this.getData(this.props);
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButtonClick);


    }
    getData(props) {
        clearInterval(this.intervalUpdateId);
        orderRequest(props.route.params.id, (isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                var showSession = false;
                var showReady = false;
                var currentSession = null;
                if (response.data.order_details != null && response.data.order_details.length > 0) {
                    if (response.data.order_details[0].sessions != null && response.data.order_details[0].sessions.length > 0) {
                        showSession = true;
                        var startedSession = response.data.order_details[0].sessions.filter(it => it.status_servant === 'start' || it.status_servant === 'arrived')
                        if (startedSession != null && startedSession.length > 0) {
                            currentSession = startedSession[0];
                        }
                        response.data.order_details[0].sessions.map(it => {
                            if (it.status_servant != null && it.status_servant === 'start' &&
                                (it.status_customer == null || it.status_customer.length === 0)) {
                                showReady = true;
                            }
                            if (it.status_servant == null && currentSession == null) {
                                currentSession = it;
                            }
                        })
                    }
                    console.log(currentSession)
                }
                var currentGeo = null;
                if (!Array.isArray(response.data.info_servant) && response.data.info_servant != null || Array.isArray(response.data.info_servant) && response.data.info_servant.length > 0) {
                    currentGeo = geojson;
                    currentGeo.features[0].geometry.coordinates = !Array.isArray(response.data.info_servant) && response.data.info_servant != null || Array.isArray(response.data.info_servant) && response.data.info_servant.length > 0 ? [parseFloat(response.data.info_servant.lng), parseFloat(response.data.info_servant.lat)] : null;
                    currentGeo.features[0].properties.title = 'سفیر سلامت'
                }
                if (response.data != null && response.data.info_order != null) {
                    clearInterval(this.intervalUpdateId);
                    this.intervalUpdateId = setInterval(() => {
                        this.getData(this.props)
                    }, 5000);
                } else {
                    clearInterval(this.intervalUpdateId);
                }

                this.setState({
                    waiting: false,
                    showSession: showSession,
                    readyPrompt: showReady,
                    currentSession: currentSession,
                    info_order: response.data.info_order,
                    info_servant: !Array.isArray(response.data.info_servant) && response.data.info_servant != null || Array.isArray(response.data.info_servant) && response.data.info_servant.length > 0 ? response.data.info_servant : null,
                    order_details: response.data.order_details,
                    expertGeo: currentGeo,
                    expert: !Array.isArray(response.data.info_servant) && response.data.info_servant != null || Array.isArray(response.data.info_servant) && response.data.info_servant.length > 0 ? [parseFloat(response.data.info_servant.lng), parseFloat(response.data.info_servant.lat)] : [0, 0],
                })
                if (response.data.info_order.status_order === 'getservant' || response.data.info_order.status_order === 'arrived') {

                        this.getCurrentPosition()

                }

            } else {
                this.setState({
                    waiting: false
                })
            }
        })
        ratePointsRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
                this.setState({
                    negatives: response.data.negative,
                    positives: response.data.positive
                })
            }
        })
    }
    getCurrentPosition() {
        try {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    var currentGeo = geojson;
                    currentGeo.features[0].geometry.coordinates = [position.coords.longitude, position.coords.latitude];
                    currentGeo.features[0].properties.title = 'مددجو'
                    this.setState({
                        region: [position.coords.longitude, position.coords.latitude],
                        regionGeo: currentGeo,
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                },
                (error) => {
                    console.log(error)
                    switch (error.code) {
                        case 1:
                            if (Platform.OS === "ios") {
                                alert( "برای تعیین موقعیت مکانی خود، اجازه استفاده از برنامه را در تنظیمات - حریم خصوصی - موقعیت مکانی را فعال کنید");
                            } else {
                                alert( "برای تعیین موقعیت مکانی خود، اجازه استفاده از برنامه را در تنظیمات - Apps - AsanDarman - Location را فعال کنید");
                            }
                            break;
                        default:
                           alert( "خطا در تشخیص موقعیت مکانی ! لطفا مجددا سعی نمایید");
                    }
                }, { enableHighAccuracy: false, timeout: 30000 }
            );
        } catch (e) {
            alert(e.message || "");
        }
    };
    updateLocation() {
        orderRequest(this.props.route.params.id, (isConnect, response) => {
            if (isConnect && response.isSuccess) {
                var currentGeo = null;
                if (!Array.isArray(response.data.info_servant) && response.data.info_servant != null || Array.isArray(response.data.info_servant) && response.data.info_servant.length > 0) {
                    currentGeo = geojson;
                    currentGeo.features[0].geometry.coordinates = !Array.isArray(response.data.info_servant) && response.data.info_servant != null || Array.isArray(response.data.info_servant) && response.data.info_servant.length > 0 ? [parseFloat(response.data.info_servant.lng), parseFloat(response.data.info_servant.lat)] : null;
                    currentGeo.features[0].properties.title = 'سفیر سلامت'
                }
                this.setState({
                    expertGeo: currentGeo,
                    expert: !Array.isArray(response.data.info_servant) && response.data.info_servant != null || Array.isArray(response.data.info_servant) && response.data.info_servant.length > 0 ? [parseFloat(response.data.info_servant.lng), parseFloat(response.data.info_servant.lat)] : [0, 0],
                })
            }
        })
    }
    handleBackButtonClick() {
        if (this.state.info_order != null) {
            if (this.state.info_order.status_order === 'arrived') {
                BackHandler.exitApp();

            } else if (this.state.info_order.status_order === 'getservant') {
                if (this.state.showSession) {
                    if (this.state.currentSession != null) {
                        if (this.state.currentSession.status_servant === 'start') {
                            BackHandler.exitApp();
                        } else if (this.state.currentSession.status_servant === 'arrived') {
                            BackHandler.exitApp();
                        } else {
                            this.props.navigation.goBack();
                            return true;
                        }
                    } else {
                        this.props.navigation.goBack();
                        return true;
                    }
                } else {
                    BackHandler.exitApp();
                }
            } else if (this.state.info_order.status_order === 'waitting') {
                BackHandler.exitApp();
            } else {
                this.props.navigation.goBack();
                return true;
            }
        } else {
            this.props.navigation.goBack();
            return true;
        }


    }
    componentWillReceiveProps(newprops) {
        console.log('componentWillReceiveProps')
        this.getData(newprops);
    }
    componentDidMount() {
        console.log('componentDidMount')
        clearInterval(this.intervalId);
        this.intervalId = setInterval(() => {
            this.updateLocation()
        }, 30000);
        AppState.addEventListener('change', this._handleAppStateChange);
    }
    componentWillUnmount() {
        console.log('componentWillUnmount')
        clearInterval(this.intervalId)
        clearInterval(this.intervalUpdateId)
        AppState.removeEventListener('change', this._handleAppStateChange);
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackButtonClick);
    }
    _handleAppStateChange = (nextAppState) => {
        console.log('nextAppState: ' + nextAppState)
        if (this.state.appState.match(/inactive|background/) && nextAppState === 'active') {
            if (this.state.gotopay) {

                this.getData(this.props)
            }
        } else {
            clearInterval(this.intervalId)
            clearInterval(this.intervalUpdateId)
        }
        this.setState({ appState: nextAppState });
    }
}
